const MAIN_FEEDS = ['home', 'search', 'following'];

export default MAIN_FEEDS;